import { LOGO_URL, WORDMARK_URL } from "../consts";

export default function Logo() {
  return (
    <div className="flex flex-shrink-0 items-center">
      <img
        alt="GioJoy Logo"
        src={LOGO_URL}
        className="h-14 w-auto mr-2"
      />
      <img
        alt="GioJoy"
        src={WORDMARK_URL}
        className="h-12 w-auto"
      />
    </div>
  );
}
